
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "BookTypeOption"
})
export default class extends Vue {
  @Prop({ required: true }) private value!: string;

  private options = ["xlsx", "csv", "txt"];

  get bookType() {
    return this.value;
  }

  set bookType(value) {
    this.$emit("input", value);
  }
}
